var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGateio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 600 0 600 600 0 600"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6362\\u8272",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(100 100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    transform: "translate(-1755.000000, -5518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(1755.000000, 5518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,464.998427 C208.873069,464.998427 134.996504,391.122566 134.996504,299.996504 C134.996504,208.870442 208.873069,135.000938 300,135.000938 L300,-0.000635600624 C134.310049,-0.000635600624 0,134.314489 0,299.996504 C0,465.67852 134.310049,600 300,600 C465.689951,600 600,465.67852 600,299.996504 L465.003496,299.996504 C465.003496,391.122566 391.126931,464.998427 300,464.998427",
    id: "Fill-1",
    fill: "#2354E6",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#17E6A1",
    points: "299.992373 299.99714 464.995869 299.99714 464.995869 134.995217 299.992373 134.995217"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateio);
export default __webpack_public_path__ + "static/media/gateio.9f8af5b9ff42de79ed3baec07c910a26.svg";
export { ForwardRef as ReactComponent };